<template>
    <toolbox-pane class="dashboard-toolbox">
        <tabs :tabs="tabs">
            <template #tab-content-feel>
                <section class="toolbox-square-buttons px-3 mt-4" v-for="section in sections" :key="section">
                    <h6 class="font-weight-semi-bold mb-2">{{ section }}</h6>
                    <div class="row">
                        <div class="col-3 mb-2" v-for="i in 10">
                            <square-btn icon="video-camera" class="btn-light">Media</square-btn>
                        </div>
                    </div>
                </section>
            </template>
        </tabs>
    </toolbox-pane>
</template>

<script>
import ToolboxPane from "@/Components/ToolboxPane";
import Tabs from "@/Components/Tabs";
import SquareBtn from "@/Components/SquareBtn";
export default {
    name: "DashboardToolbox",
    components: {SquareBtn, Tabs, ToolboxPane},

    data(){
        return {

            tabs: {
                feel: 'Feel',
                imagine: 'Imagine',
                do: 'Do',
                share: 'Share',
            },

            sections: [
                'Online Research',
                'Stakeholder Analysis',
                'Problem Analysis',
            ],
        }
    }

}
</script>

<style lang="scss" scoped>
.dashboard-toolbox{
    width: 320px;
}
.toolbox-square-buttons{
    margin-bottom: 1rem;

    .row{
        margin-left: -0.3rem;
        margin-right: -0.3rem;

        > * {
            padding-left: 0.3rem;
            padding-right: 0.3rem;
        }
    }
}
</style>
